import { IScope } from "angular";
import { StateDeclaration, TransitionService, UIRouterGlobals } from "@uirouter/angularjs";
import { first } from "rxjs";
import { NewHomeExperienceService } from "@webapp/home/services/new-home-experience.service";

interface IRootLayoutScope extends IScope {
  backgroundColor?: string;
  useNewLayout?: boolean;
}

export class RootLayoutCtrl {
  static $inject = ["$scope", "$transitions", "$uiRouterGlobals", "NewHomeExperienceService"];

  constructor(
    private $scope: IRootLayoutScope,
    $transitions: TransitionService,
    $uiRouterGlobals: UIRouterGlobals,
    private newHomeExperienceService: NewHomeExperienceService
  ) {
    this.setScopePropertiesFromState($uiRouterGlobals.current);

    $scope.$on(
      "$destroy",
      $transitions.onSuccess({}, (trans) => {
        const to = trans.to();
        this.setScopePropertiesFromState(to);
      })
    );
  }

  private setScopePropertiesFromState(state: StateDeclaration): void {
    this.$scope.backgroundColor = state.data?.pageBackgroundColor;
    this.$scope.useNewLayout = state.data?.newLayout === true;

    if (state.name.includes("gtmhub.home.dashboard")) {
      this.newHomeExperienceService
        .isNewHomeDashboardEnabled$()
        .pipe(first())
        .subscribe((isNewHomeDashboardEnabled) => {
          let newLayout = state.data?.newLayout === true;
          let pageBackgroundColor = state.data?.pageBackgroundColor;

          if (isNewHomeDashboardEnabled) {
            // TODO: https://quantive-inc.atlassian.net/browse/GVS-50124
            newLayout = true;
            pageBackgroundColor = "#e8ecf2";
          }

          this.$scope.backgroundColor = pageBackgroundColor;
          this.$scope.useNewLayout = newLayout;
        });
    }
  }
}
